// Define header cells for the excel download
export const excelHeaderCellsName = {
  التقييم: "rating",
  "رقم الطلب": "orderId",
  "اسم المتبرع": "donorName",
  "هاتف المتبرع": "donorPhone",
  "إجمالي سعر الطلب": "orderTotalPrice",
};
